"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TextInput.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TextInput = _ref => {
  let {
    name,
    label,
    placeholder,
    value,
    inputChange,
    status,
    required
  } = _ref;
  const statusMessage = {
    error: "has-error",
    success: "has-success"
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-form-item ${status && statusMessage[status.className]}`
  }, label && !required && /*#__PURE__*/_react.default.createElement("label", {
    className: "ter-form-item__label",
    htmlFor: name
  }, label), label && required && /*#__PURE__*/_react.default.createElement("label", {
    className: "ter-form-item__label",
    htmlFor: name
  }, label, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-form-item__required-tag"
  }, "*")), /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    name: name,
    placeholder: placeholder,
    value: value,
    onChange: e => inputChange(e),
    className: `ter-input`
  }), status?.message && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-form-item__status-message"
  }, status.message));
};
var _default = TextInput;
exports.default = _default;
TextInput.propTypes = {
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  inputChange: _propTypes.default.func.isRequired,
  status: _propTypes.default.shape({
    className: _propTypes.default.string.isRequired,
    message: _propTypes.default.string
  }),
  name: _propTypes.default.string.isRequired
};